// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.aircraft-type,\n.el-table th.aircraft-type {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
